import Layout from "@/layouts/Layout";
import IndexLayout from "@/layouts/resources/IndexLayout";
import craftBatch from "@/lib/craftBatch";
import getCommonServerSideProps from "@/lib/getCommonServerSideProps";
import QueryResourceCollections from "@/queries/craft/QueryResourceCollections.graphql";
import QueryResourcesIndexPage from "@/queries/craft/QueryResourcesIndexPage.graphql";
import { observer } from "mobx-react";
import { getServerSession } from "next-auth/next";
import { authOptions } from "pages/api/auth/[...nextauth]";
import React from "react";

export async function getServerSideProps({
  preview,
  params,
  req,
  res,
  query,
  locale,
}) {
  const commonProps = await getCommonServerSideProps({
    req,
    res,
    query,
    locale,
  });

  const session = await getServerSession(req, res, authOptions);

  const queries = [
    {
      document: QueryResourcesIndexPage,
      variables: { site: commonProps.site },
    },
    {
      document: QueryResourceCollections,
      variables: {
        users: [":empty:", session?.user.id],
        organisations: [":empty:", session?.user.organisation?.id],
      },
    },
  ];

  const response = await craftBatch(queries);

  const { pageEntry } = response[0];

  if (!pageEntry) {
    return {
      notFound: true,
    };
  }

  const { resourceCollections } = response[1];

  return {
    props: {
      ...commonProps,
      pageEntry,
      resourceCollections,
    },
  };
}

const ResourcesIndex = () => {
  return <></>;
};

const ResourceLayout = (page) => {
  const {
    navigation,
    pageEntry,
    resourceCollections,
    site,
    siteLogo,
    organisation,
    hideYcnBranding,
  } = page.props;

  return (
    <Layout
      site={site}
      navigation={navigation}
      siteLogo={siteLogo}
      organisation={organisation}
      hideYcnBranding={hideYcnBranding}
    >
      <IndexLayout
        site={site}
        pageEntry={pageEntry}
        resourceCollections={resourceCollections}
        resourceBasePath="/resources/collections/index"
      >
        {page}
      </IndexLayout>
    </Layout>
  );
};

ResourcesIndex.getLayout = ResourceLayout;

ResourcesIndex.displayName = "ResourcesIndex";

export default observer(ResourcesIndex);
